import {
    Box,
    Heading,
    Text,
    VStack
} from '@chakra-ui/react';
import React from 'react';

interface SidebarSectionProps {
  title: string;
  children: React.ReactNode;
  description?: string;
}

const SidebarSection: React.FC<SidebarSectionProps> = ({ title, description, children }) => {
  const titleColor = 'gray.600';
  const descriptionColor = 'gray.500';

  return (
    <Box mb={6}>
      <Heading
        size="xs"
        fontWeight="normal"
        fontFamily="body"
        mb={1}
        color={titleColor}
      >
        {title}
      </Heading>
      {description && (
        <Text
          fontSize="xs"
          mb={2}
          color={descriptionColor}
        >
          {description}
        </Text>
      )}
      <VStack spacing={1} align="stretch" pl={2}>
        {children}
      </VStack>
    </Box>
  );
};

export default SidebarSection;
